import { Box } from '@mui/material'

import { ContentCard } from './ContentCard'
import { InlineLoader } from './InlineLoader'

type Props = {
  message?: string
  height?: number
}

export const ContentLoader = (props: Props) => {
  const message = props.message || 'Loading...'

  return (
    <ContentCard>
      <InlineLoader />
      <Box style={{ textAlign: 'center', height: props.height || 'auto' }}>{message}</Box>
    </ContentCard>
  )
}
